<template>
  <section>
    <PageTitle title="Bayked Orders Review" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/bayked_orders_feedback',title:'Bayked Orders Feedback'}]" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-title">
            <h5>{{$store.getters.getValidPlatform}} Orders Feedback</h5>
            <StarRating class="pull-right"
                        v-if="showRating && selectedRestaurant"
                        :rating="selectedRestaurant.averageRating"
                        :read-only="true"
                        :star-size="20"
                        :show-rating="false"
                        :animate="true"
                        :title='"Restaurant Rating : "+selectedRestaurant.averageRating'
                        :increment="0.01">
            </StarRating>
          </div>
          <div class="ibox-content">
<!--            Filters-->
            <div class="row">
              <div style="height: 90px" class="col-md-3">
                <div class="form-group">
                  <label>Order id</label>
                  <input placeholder="Order Id" id="orderId" class="form-control" v-model="orderId" />
                </div>
              </div>
              <div style="height: 90px" class="col-md-3">
                <label>Restaurants</label>
                <Multiselect id="filter1"
                              v-model="selectedRestaurant"
                             :options="allRestaurants"
                             :allow-empty="false"
                             label="name"
                             track-by="name"></Multiselect>
              </div>
              <div style="height: 90px" class="col-md-3">
                <label>Branches <b v-if="!selectedRestaurant" class="text-danger text-sm">(select restaurant)</b></label>
                <Multiselect id="filter2"
                             v-model="selectedBranch"
                             :options="allBranches"
                             label="name"
                             track-by="name"
                             :disabled="!selectedRestaurant"
                             placeholder="Select Restaurant Branch"></Multiselect>
              </div>
              <div style="height: 90px" class="col-md-3">
                <SearchCustomerByNameAndContactNumber
                    ref="searchCustomerMultiselect"
                    :bayked-orders=true
                    @selectedCustomer="fetchSelectedCustomer" />
              </div>
              <div style="height: 90px" class="col-md-3">
                <label>Rating</label>
                <Multiselect id="rating"
                             v-model="selectedRating"
                             :options="ratingRange"
                             :searchable=false
                             placeholder="Select Rating" />
              </div>
              <div style="height: 90px" class="col-md-3">
                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
              </div>
            </div>
            <br/>
<!--            Datatable-->
            <div class="row">
              <div class="col-lg-12">
                <div class="ibox-content">
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover" id="dtTable">
                      <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Restaurant Name</th>
                        <th>Branch Name</th>
                        <th>Customer Name</th>
                        <th>Customer Phone</th>
                        <th>Start Rating</th>
                        <th>Customer Feedback</th>
                      </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
          </div>

            <ViewOrder showActions="false" ref="viewOrderComp"/>
        </div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect';
import PageTitle from "../components/layout_components/PageTitle";
import ViewOrder from "../components/orders/ViewOrder";
import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber";
import {getAllBranchesOfRestaurant, getAllRestaurant} from "../api/restaurants";
import StarRating from 'vue-star-rating';


export default {
  name: "BaykedOrdersFeedback",
  components: {PageTitle, Multiselect, ViewOrder, SearchCustomerByNameAndContactNumber, StarRating},
  data: function(){
    return {
      loggedInRole: "",
      allRestaurants: [],
      selectedRestaurant: null,
      allBranchesObject: [],
      selectedBranch: null,
      dtTable: null,
      showRating: 0,
      selectedCustomer: '',
      selectedRating: "All",
      ratingRange: ["All", "4 - 5", "3 - 4", "2 - 3", "1 - 2", "0 - 1"],
      orderId: null
    }
  },
  async mounted() {
    await this.fetchRestaurantsAndBranches();
    await this.jQueryOnRefreshAndSearchBtn();
    await this.initializeDataTable();
  },
  computed: {
    allBranches() {
      return this.allBranchesObject.map((item) => {
        return {
          "id": item.id,
          "name": item.areasByAreaId.name,
        };
      })
    }
  },
  watch: {
    selectedRestaurant: async function () {
      if (this.selectedRestaurant !== null) {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant.id);
        let restaurantBranches = await getAllBranchesOfRestaurant(params);
        this.allBranchesObject = restaurantBranches.data;
        this.selectedBranch = null;
      }
    }
  },
  methods: {
    fetchSelectedCustomer(val) {
      this.selectedCustomer = val
    },
    async fetchRestaurantsAndBranches() {
      this.loggedInRole = this.$store.getters.user.userRolesById[0].role;
      if (this.loggedInRole === 'ROLE_USER' || this.loggedInRole === 'ROLE_FRANCHISE') {
        let user_restaurant = this.$store.getters.user.restaurant;
        this.selectedRestaurant = user_restaurant;
        let params = new URLSearchParams();
        params.append("restaurant_id", user_restaurant.id);
        let resp = await getAllBranchesOfRestaurant(params);
        this.allBranchesObject = resp.data;
      }else{
        let resp = await getAllRestaurant();
        this.allRestaurants = resp.data;
      }
    },
    jQueryOnRefreshAndSearchBtn(){
      let self= this;
      $(".search_filter_order_btn").click( function () {
        self.showRating = true;
        self.dtTable.column(1).search('');
        self.dtTable.column(2).search('');
        self.dtTable.column(3).search('');
        self.dtTable.column(4).search('');
        self.dtTable.column(5).search('');
        if(self.selectedRestaurant !== null){
          self.dtTable.column(1).search(self.selectedRestaurant.id);
        }if(self.selectedBranch !== null){
          self.dtTable.column(2).search(self.selectedBranch.id);
        }if(self.selectedCustomer !== null){
          self.dtTable.column(3).search(self.selectedCustomer.id);
        }if(self.selectedRating !== null){
          self.dtTable.column(4).search(self.selectedRating[0] !== "A" ? self.selectedRating[0]: "");
        }if(self.orderId !== null){
          self.dtTable.column(5).search(self.orderId);
        }
        self.dtTable.draw();
      });
      $(".refresh_filter_order_btn").click( function () {
        self.showRating = false;
        self.dtTable.column(1).search('');
        self.dtTable.column(2).search('');
        self.dtTable.column(3).search('');
        self.dtTable.column(4).search('');
        self.dtTable.column(5).search('');
        self.selectedRating= "All";
        self.orderId= null;
        self.selectedBranch = null;
        if(self.loggedInRole !== 'ROLE_USER' && self.loggedInRole !== 'ROLE_FRANCHISE') {
          self.selectedRestaurant = null;
          self.allBranchesObject = [];
        }
        self.$refs.searchCustomerMultiselect.selectedCustomerTemp = ""
        self.selectedCustomer = ""
        self.dtTable.draw();
      });
    },
    initializeDataTable(){
      let self= this;
      let processingURL = this.$store.state.mainAppURL+ "orders/bayked_orders_feedback";
      this.dtTable = $('#dtTable').DataTable({
        "dom":'ltipr',
        "processing": true,
        "serverSide": true,
        "autoWidth": false,
        "order": [[0, "desc"]],
        "lengthMenu": [10, 25, 50, 100, 250],
        "pagingType": "simple",
        'language': {
          //'loadingRecords': 'Please wait - loading...',
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "ajax": {
          url: processingURL,
          type: "post",
          data: function ( d ) {
            if (self.loggedInRole==="ROLE_USER" || self.loggedInRole === 'ROLE_FRANCHISE'){
              d.restaurant_id= self.selectedRestaurant.id;
            }
            return JSON.stringify( d );
          },
          headers: {
            "Content-type": "application/json; charset=utf-8"
          },
          beforeSend:  (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dtTable);
            }
          }
        },
        "columnDefs": [
          { "orderable": false, "targets": [1, 2, 3, 4, 6] },
          { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6]},
        ],
        "columns": [
          {"data": "orderId",
            "name": "order_id",
            "render": function(data){
              return '<a data-id="'+data+'" href="javascript:void(0)" class="order_details_btn">'+ data +'</a>';
            },
          },
          { "data": "restaurantName","name":"restaurant_name" },
          { "data": "branchName","name":"branch_area" },
          {
            "data": "customerName", "name": "Customer Name",
            "render": function (data) {
              return (data === undefined) ? "N/A" : data;
            }
          },
          {
            "data": "customerContactNumber",
            "name":"contact_number",
            "render": function(data, type, row) {
              if(row.customerContactNumber === null || row.customerContactNumber === ""){
                return "N/A";
              }
              if(row.customerContactNumber.search("&")){
                return data.split("&")[0];
              }
              return data;
            }
          },
          {
            "data": "rating",
            "name": "rating",
            "render": self.averageScoreLabel
          },
          {
            "data": "feedbackText",
            "name":"feedbackText",
            "render": function (data) {
                return (data) ? (data.length > 40)  ? "<span class='tip_class' title='"+data+"'>"+data.substring(0,40)+"...</span>" : "<span>"+data : 'N/A'+"</span>";
            }
          },
        ],
        "drawCallback": function( ) {
          $(".tip_class").tooltip();
          $(".order_details_btn").click(function (event) {
            let order_id =  $(this).attr("data-id");
            self.$refs.viewOrderComp.fetchOrderDetail(order_id);
          });
        }
      });
      $.fn.dataTable.ext.errMode = 'none';
    },
    averageScoreLabel: function(data, type, row){
      let label = "";
      if(data===null){
        return "N/A"
      }
      else if(data<=1){label = 'danger'; }
      else if(data>1 && data<=2){label = 'warning'; }
      else if(data>2 && data<=4){label = 'info'; }
      else if(data>4 && data<=5){label = 'success'; }
      return "<span class='label label-" + label + "'>"+data.toFixed(2)+"</span>";
    }
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>